import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var ShoppingBagFilled = function ShoppingBagFilled(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C5.76 0 3.945 1.79 3.945 4v1H2.843a1.01 1.01 0 00-1.01.91l-.829 9A1.005 1.005 0 002.014 16h11.972c.596 0 1.064-.505 1.01-1.09l-.83-9a1.008 1.008 0 00-1.01-.91h-1.101V4c0-2.21-1.816-4-4.055-4zm2.027 5V4c0-1.105-.907-2-2.027-2s-2.027.895-2.027 2v1h4.054zm2.028 3c0 .552-.454 1-1.014 1s-1.014-.448-1.014-1 .454-1 1.014-1 1.014.448 1.014 1zM4.959 9c.56 0 1.014-.448 1.014-1s-.454-1-1.014-1-1.014.448-1.014 1 .454 1 1.014 1z",
    fill: "currentColor"
  }));
};
export default ShoppingBagFilled;